import { render, staticRenderFns } from "./event-company.vue?vue&type=template&id=444d4af6&"
import script from "./event-company.vue?vue&type=script&lang=js&"
export * from "./event-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports